<template>
  <section>
    <label v-if="label" class="teams-label-font">
      {{ label }}
      <span v-if="mandatory" class="asterik">*</span>
    </label>
    <div class="select-div">
      <div
        class="
          selectCustom-field
          d-flex
          align-items-center
          justify-content-between
          pointer
        "
        ref="multi-select-search"
        tabindex="0"
        @click="!disabled ? toggleDropdown() : ''"
        :class="{ error: showError }"
      >
        <span
          class="text-truncate"
          :class="
            selectedValues.length > 0
              ? 'inputPlaceholder-font'
              : 'input-empty-placeholder'
          "
        >
          {{
            selectedValues.length == 0
              ? placeholder
              : id === "access-roles"
              ? selectedValues.join(" + ")
              : `${selectedValues.length} Selected`
          }}
        </span>
        <span>
          <img
            v-if="!showDropdown"
            src="../../assets/cvsearch/cv-downarrow.svg"
            alt
          />
          <img
            v-else
            class="pointer"
            src="../../assets/cvsearch/cv-uparrow.svg"
            alt
          />
        </span>
      </div>

      <div
        v-closable="{
          exclude: ['multi-select-search'],
          handler: 'hideDropdown',
        }"
        v-if="showDropdown && !disabled"
        class="acess-cj-filter-modal pointer newManage-checkbox"
      >
        <div class="relativeclass">
          <div class="recsearchicon-pos">
            <img src="@/assets/img/accessconnew/inputsearch.svg" alt />
          </div>
          <b-form-input
            class="acs-inputField"
            type="search"
            placeholder="Search"
            debounce="500"
            v-model="searchQuery"
            @update="searchData"
          ></b-form-input>
          <b-form-checkbox-group
            v-model="selectedValues"
            class="
              w-100
              selectCustom-dropdown-innerContent
              common-single-checkbox
              check-truncate
            "
            @change="$emit('select-value', selectedValues)"
            :disabled="disabled"
            disabled-field="notEnabled"
            style="max-height: 122px !important"
          >
            <b-form-checkbox
              v-for="(option, index) in dropdownOptions"
              :key="index"
              :value="option.key"
              :class="
                selectedValues.includes(option.key) &&
                'qb-dropdown-option-selected'
              "
            >
              <span>{{ option.label }}</span>
            </b-form-checkbox>
          </b-form-checkbox-group>

          <div
            class="kanban-more-option-card-input text-center w-100"
            v-if="dropdownOptions.length == 0 && searchQuery !== ''"
          >
            <!-- No {{ id === "access-roles" ? "roles " : label }} found -->
            No data found
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "MultiSearch",
  props: {
    id: String,
    label: String,
    placeholder: String,
    mandatory: Boolean,
    dropdown: Object,
    disabled: Boolean,
    showError: Boolean,
    vmodel: {
      validator: function () {
        return true;
      },
    },
  },
  data() {
    return {
      searchQuery: "",
      showDropdown: false,
      selectedValues: [],
      dropdownOptions: [],
      fullData: [],
      preventClose: false,
    };
  },
  created() {
    if (this.vmodel && this.vmodel.length != 0)
      this.selectedValues = this.vmodel;
    this.checkAndSetOptions();
  },
  watch: {
    vmodel(val) {
      this.selectedValues = val;
    },
    "dropdown.options"() {
      if (!this.searchQuery) {
        this.checkAndSetOptions();
      }
    },
  },
  methods: {
    checkAndSetOptions() {
      const allObjects = this.dropdown.options.every(
        (item) =>
          typeof item === "object" && item !== null && !Array.isArray(item)
      );
      if (allObjects) {
        if (this.dropdown.dropdownValue && this.dropdown.dropdownLabel) {
          this.dropdownOptions = this.dropdown.options.map((obj) => {
            obj.key = obj[this.dropdown.dropdownValue];
            obj.label = obj[this.dropdown.dropdownLabel];
            return obj;
          });
        } else if (this.id === "access-roles") {
          this.dropdownOptions = this.dropdown.options.map((obj) => {
            obj.label = obj.roleName;
            obj.key = obj.roleName;
            return obj;
          });
        } else this.dropdownOptions = this.dropdown.options;
      } else {
        this.dropdownOptions = [];
        this.dropdown.options.map((obj) => {
          let values = {};
          values.key = obj;
          values.label = obj;
          this.dropdownOptions.push(values);
        });
      }
      this.fullData = this.dropdownOptions;
    },
    searchData() {
      if (this.dropdown.searchType === "api") {
        this.$emit("search-data", this.searchQuery);
      } else {
        this.dropdownOptions.filter((option) =>
          option.label.toLowerCase().includes(this.searchQuery.toLowerCase())
        );
        if (this.searchQuery == "" || this.searchQuery == null) {
          this.dropdownOptions = this.fullData;
        } else {
          // Filter options that start with the selected input
          const startsWithSelected = this.fullData.filter((option) =>
            option.label
              .toLowerCase()
              .startsWith(this.searchQuery.toLowerCase())
          );
          // Filter options that contain the selected input
          const containsSelected = this.fullData.filter(
            (option) =>
              !option.label
                .toLowerCase()
                .startsWith(this.searchQuery.toLowerCase()) &&
              option.label
                .toLowerCase()
                .includes(this.searchQuery.toLowerCase())
          );
          // Concatenate startsWithSelected options followed by containsSelected options
          this.dropdownOptions = [...startsWithSelected, ...containsSelected];
        }
        this.showDropdown = true;
      }
    },
    hideDropdown() {
      this.showDropdown = false;
    },
    handleFocusIn() {
      this.showDropdown = !this.showDropdown;
    },
    handleKeydown(event) {
      if (event.key === "Tab") {
        this.showDropdown = false; // Close the dropdown when Tab is pressed
      }
    },
    handleDropdownOpen() {
      this.preventClose = true;
    },
    toggleDropdown() {
      //   if (!this.preventClose) {
      this.showDropdown = !this.showDropdown;
      //     this.preventClose = false; // Reset the flag here
      //   } else {
      //     this.preventClose = false; // Reset the flag here
      //   }
    },
  },
};
</script>

<style></style>
